// src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './theme.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Élément #root introuvable dans le DOM')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
